<template>
  <div class="hello">
       
        <div class="login">
            <div class="wrap">
              <div class="txt-center col-white pt-50">
                <span class="font-20">CARROT</span>
                <br>
                <span class="font-30 bold" >My Class</span>
                <br><br>
                <p>
                  <span class="bold">비밀번호를 재설정</span> 해주세요!
                  <br>
                  비밀번호는 숫자+영어 대소문자+특수문자(8자이상)을
                  입력해주세요
                  <!-- CARROT 초과학습센터에 <br class="br">오신걸 환영합니다!<br>
                  로그인하여 <span class="bold">나의 수업에 활용</span>해 보세요! -->
                </p>
              </div>

                <div class="box mt-40">
                    <label for="">
                        <input type="text" placeholder="ID(E-mail)를 입력해 주세요." class="w-100per mb-20" v-model="member.uid" readonly>
                    </label>
                    <label for="">
                        <input type="password" placeholder="비밀번호를 입력해 주세요" class="w-100per mb-20" v-model="passwd">
                    </label>
                    <label for="">
                        <input type="password" placeholder="비밀번호를 한번 더 입력해 주세요." class="w-100per" v-model="passwdr">
                    </label>
                    <!-- <p class="col-red mt-05">E-mail 혹은 비밀번호를 다시 입력해 주세요.</p> -->
                  
                    <a href="#" onclick="return false;" class="btn-login w-100per mt-20" @click="doReset()">재설정 하기</a>
                </div>

                <p class="copyright">Copyright© <span class="bold">CARROT</span> Global Inc. All rights reserved.</p>
            </div>
        </div>

        <!-- 푸터 -->
        <!-- <div class="footer clear">
            Copyright© <span class="bold">CARROT</span> Global Inc. All rights reserved.<br>
        </div> -->
  </div>
</template>

<script>
export default {
  name: 'RestPw',
  props: {
    msg: String
  },
    
    data: () => ({
        uidx:"",
        member:[],
        passwd:"",
        passwdr:""
    }),
   mounted() {
    //    this.doc_del_rendar();
        this.uidx = this.$route.query.uidx;
        if(location.hostname == "stagest.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
        }else if(location.hostname == "st.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.hostname == "student.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.hostname == "m.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.href.includes("how")){
            if(location.href.includes("stage")){
                this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
            }else{
                this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
            }
        }else{
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }
        this.initPop();
   },
   methods: {
       doReset(){
           if(this.passwd == ""){
               alert("비밀번호를 입력해주세요.");
               return false;
           }
           if(this.passwdr == ""){
               alert("비밀번호를 입력해주세요.");
               return false;
           }

            var num = this.passwd.search(/[0-9]/g);
            var eng = this.passwd.search(/[a-z]/ig);
            var spe = this.passwd.search(/[`~!@@#$%^&*|₩₩₩'₩";:₩/?]/gi);
            if(this.passwd.length < 8 || this.passwd.length > 20){
                alert("비밀번호는 숫자+영어 대소문자+특수문자(8자 이상)로 입력해 주세요.");
                return false;
            }else if(this.passwd.search(/\s/) != -1){
                alert("비밀번호는 숫자+영어 대소문자+특수문자(8자 이상)로 입력해 주세요..");
                return false;
            }else if(num < 0 || eng < 0 || spe < 0){
                alert("비밀번호는 숫자+영어 대소문자+특수문자(8자 이상)로 입력해 주세요.");
                return false;
            }

            if(this.passwd != this.passwdr){
                alert("비밀번호가 맞지 않습니다.");
                return false;
            }


            var params  = {
                uidx : this.uidx,
                passwd : this.passwd,
                passwdr : this.passwdr,
                email : this.member.uid
            };

            if(confirm("비밀번호를 재설정하시겠습니까?") == true){
                this.axios.post(this.$store.state.host + "/rest/mobile/resetPw",params).then(function(res){
                    // console.log(res);
                    if(res.data.err == 0){
                        alert("비밀번호 재설정이 완료되었습니다. 다시 로그인 해주세요.");
                        location.href="/login";
                    }else{
                        alert(res.data.err_msg);
                    }
                });
            }
       },
       initPop() {
            var params = {
                uidx: this.uidx
            };
            var me = this;
            this.axios.get(this.$store.state.host + '/rest/mobile/getMemberByIdx', {
                params: params
            }).then(function (res) {
                // console.log(res.data.member);
                me.member = res.data.member;

            });
        }
   }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$point-color: #53CAFF;
$purple: #6974FF;
$gray: #B7B7B7;
$border-color: #E9E9E9; 
$back-gray: #F5F5F5;

// 결석
$absent: #FF4068;
// 출석
$attend: #53CAFF;
// 휴강
$cancel: #FFB055;
// 예정
$scheduled: #E1E1E1;
// 공결
$reasons: #2FEECD;
.wrap {
    width: 90%;
    max-width: 700px;
    margin: 0 auto;
}

//
.login {
    background: url("../assets/img/login-bg.png") no-repeat center -250px;
    .wrap {
        max-width: 500px;
    }
    h1 {
        padding-top: 40px;
        span {
            
            font-size: 18px;
            color: #ffffffb3;
            display: block;
        }
    }
    .box {
        border-radius: 20px;
        padding: 20px;
        background: #ffffff;
        border-radius: 20px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
    -webkit-box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
        p {
            font-size: 14px;
        }
        label{
            width: 100%;
        }
    }

    .copyright{
        font-size: 12px;
        color: #CCCCCC;
        text-align: center;
        padding-top: 30px;
    }
}
@media only screen and (max-width: 414px){
  .box {
      border-radius: 0px;
      box-shadow: none;
      -webkit-box-shadow: none;
      -moz-box-shadow: none;
  }
}
input[type="text"], input[type="password"]{
  border-radius: 0;
    border-top: none;
    border-right: none;
    border-left: none;
    border-bottom: 1px solid #E9E9E9;
    font-size: 16px;
    height: 45px;
    padding: 0 10px;
}
input[type="checkbox"] {
    display: none;
}

input[type="checkbox"] + span {
    display: inline-block;
    width: 15px;
    height: 15px;
    background: none;
    border: 1px solid $point-color;
    cursor: pointer;
    vertical-align: middle;
}

input[type="checkbox"]:checked + span {
    width: 15px;
    height: 15px;
    background: $point-color url("../assets/img/checkbox.png") no-repeat center;
    background-size: 12px;
}

.btn-login {
    display: inline-block;
    background: $point-color;
    font-size: 18px;
    font-weight: bold;
    color: #ffffff;
    text-align: center;
    border-radius: 10px;
    padding: 10px 0;
}
</style>
